module.exports = __webpack_public_path__ + "img/img_login_photo.08249fb1.png";